import axios from "axios";
const baseApi = 'https://journalapi.rhc.ac.ir'; 

export const getCartable = async ( pageNo = 1, perPage = 10) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            "https://journalapi.rhc.ac.ir/Admin/GetCartable",
            {
                pageNo: pageNo,
                perPage: perPage,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
       
        localStorage.setItem("token", response.data.meta.token);
        console.log(response.data.meta.token) ;

        return response.data;
    } catch (error) {
        console.error("Axios error:", error.response?.data || error.message);
        return null
    }
};

export const getArticleStepDetail = async (articleId) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            "https://journalapi.rhc.ac.ir/Admin/GetArticleStepDetail",
            {
                articleStepId: articleId
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
       
        //localStorage.setItem("token", response.data.meta.token);

        //console.log("from api:",response.data) ;

        return response.data;
    } catch (error) {
        console.error("Axios error:", error.response?.data || error.message);
        return null
    }
};


export const getCartableCount = async () => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            "https://journalapi.rhc.ac.ir/Admin/GetGeneralInfo",
            {

            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
       
        localStorage.setItem("token", response.data.meta.token);
       
        return response.data;
    } catch (error) {
        console.error("Axios error:", error.response?.data || error.message);
        return null
    }
};

export const cartableAction = async (articleId,endpoint,description) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
            `${baseApi}${endpoint}`,

            {
                articleId: articleId ,
                comment: description
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
       
        //localStorage.setItem("token", response.data.meta.token);

        //console.log("from api:",response.data) ;

        return response.data;
    } catch (error) {
        console.error("Axios error:", error.response?.data || error.message);
        return null
    }
};